import { t } from 'i18next';
import { Button } from '@peacecover/component';
import { ArrowLeft, CheckCircleFill } from '@peacecover/icon';
import { useBettieSettingInfo } from '../../hooks/useBettieSettingInfo';

interface ProfileImagePreviewProps {
  bettieProfileImage: string;
  previewObjectUrl: string | null;
  clearBettieProfileImage: () => void;
  onConfirm: () => void;
  showRecommendToggle?: boolean;
}

const ProfileImagePreview = ({
  bettieProfileImage,
  previewObjectUrl,
  clearBettieProfileImage,
  onConfirm,
  showRecommendToggle = true
}: ProfileImagePreviewProps) => {
  const handleBackClick = () => {
    clearBettieProfileImage();
  };

  const { bettieSettingInfo, updateBettieSettingInfo } = useBettieSettingInfo();
  const isRecommendProfileImage = bettieSettingInfo.isRecommendProfileImage;

  return (
    <div className="bg-pure-black min-h-screen pt-[env(safe-area-inset-top)] fixed inset-0 flex flex-col">
      <header className="fixed top-[env(safe-area-inset-top)] left-0 right-0 z-50 p-[16px]">
        <ArrowLeft size={24} className="text-main-dark-1" onClick={handleBackClick} />
      </header>
      <div className="flex-1 flex flex-col items-center justify-center px-[24px] pt-[80px] pb-[200px]">
        <img
          src={previewObjectUrl || bettieProfileImage || ''}
          alt="selectedImage"
          className="w-[218px] h-[218px] rounded-full object-cover"
        />
      </div>
      <div className="fixed left-0 right-0 bg-pure-black px-[24px] bottom-0 pb-[calc(env(safe-area-inset-bottom)+10px)]">
        {showRecommendToggle ? (
          <button
            type="button"
            onClick={() =>
              updateBettieSettingInfo({ isRecommendProfileImage: !isRecommendProfileImage })
            }
            className="mb-[39px] mx-auto w-fit flex items-center gap-[7px]"
          >
            <CheckCircleFill
              size={24}
              backgroundColor={
                isRecommendProfileImage ? '#5C3DFA' : 'rgba(255, 255, 255, 0.20)'
              }
              strokeColor={isRecommendProfileImage ? '#FFFFFF' : '#B9B9B9'}
            />
            <p className="text-pure-white text-[15px] leading-[18px]">
              {t('BettieSetting.recommendProfileImage')}
            </p>
          </button>
        ) : null}
        <Button size="large" className="w-full text-[17px] font-semibold" onClick={onConfirm}>
          {t('confirm')}
        </Button>
      </div>
    </div>
  );
};
export default ProfileImagePreview;
